import * as Rx from 'rxjs/Rx'
import { Action, Store } from 'redux'
import { ActionsObservable, combineEpics } from 'redux-observable'

import Dependencies from '../Dependencies'
import Epic from '../Epic'
import State from '../../states'
import { Comment, Photo, Router, Toolbar, World } from '../../actions'
import { isImage } from '../../states/WorldState'
import { matchPhotoRoute } from '../../states/RouterState'

// Add photo map object
export const addPhotoMapObject = (
  action$: ActionsObservable<Action>,
  store: Store<State>,
  { logger }: Dependencies
) =>
  action$.filter(World.sessionCreated.match).switchMap(() =>
    Rx.Observable
      .of(store.getState().router.location!)
      .concat(
        action$
          .filter(Router.locationChange.match)
          .map(({ payload }) => payload)
      )
      .map(location => matchPhotoRoute(location.pathname))
      .filter(match => !!match)
      .switchMap(match => {
        const state = store.getState()
        const { id } = match!.params
        const mapObject = state.world.mapObjects[id]
        if (mapObject) {
          return Rx.Observable.empty()
        }
        logger.info('Add photo map object for photo route', id)
        return Rx.Observable.of(World.addMapObject({ id, type: 'image' }))
      })
  )

// Load comments for photo
export const loadPhotoComments = (
  action$: ActionsObservable<Action>,
  _store: Store<State>
) =>
  action$
    .filter(Router.locationChange.match)
    .map(({ payload }) => payload)
    .map(location => matchPhotoRoute(location.pathname))
    .filter(match => !!match)
    .map(match => Comment.loadPhotoComments.started(match!.params.id))

// update photo loved
export const updatePhotoLoved = (
  action$: ActionsObservable<Action>,
  store: Store<State>
) =>
  action$.filter(Photo.loveTapped.match).switchMap(() => {
    const state = store.getState()
    if (state.login.user!.guest) {
      return Rx.Observable.of(Toolbar.showSignUpPromoteModal())
    }
    const { photoID } = state.ui
    if (!photoID) {
      return Rx.Observable.empty()
    }
    const mapObjectState = state.world.mapObjects[photoID]
    if (!mapObjectState || !mapObjectState.loaded) {
      return Rx.Observable.empty()
    }
    const mapObject = mapObjectState.mapObject
    if (!isImage(mapObject)) {
      return Rx.Observable.empty()
    }
    return Rx.Observable.of(
      Photo.updatePhoto.started({ id: photoID, loved: !mapObject.loved })
    )
  })

// Post comment
export const postComment = (
  action$: ActionsObservable<Action>,
  store: Store<State>
) =>
  action$.filter(Comment.submitPhotoComment.match).mergeMap(({ payload }) => {
    if (!payload.content.trim().length) {
      return Rx.Observable.empty()
    }
    const state = store.getState()
    if (state.login.user!.guest) {
      return Rx.Observable.of(Toolbar.showSignUpPromoteModal())
    }
    return Rx.Observable.of(Comment.postPhotoComment.started(payload))
  })

export default combineEpics<Epic>(
  addPhotoMapObject,
  loadPhotoComments,
  updatePhotoLoved,
  postComment
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/routes/photo.ts